import { Component, OnInit, ViewChild } from '@angular/core';
import { RebateRequestDefineRebateComponent } from '../rebate-request-define-rebate/rebate-request-define-rebate.component';
import { LongHaulRequestOption, LongHaulReviewRebate, LongHaulOptionRebateReview, LongHaulDefineRebate } from 'src/app/shared/models/long-haul.model';
import { User } from 'src/app/front-user/shared/models/user.model';
import { LongHaulService } from 'src/app/shared/services/long-haul.service';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { Router } from '@angular/router';
import { ErrorsEnum } from 'src/app/shared/models/enums.model';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';

@Component({
  selector: 'app-rebate-request-review-rebate',
  templateUrl: './rebate-request-review-rebate.component.html'
})

export class RebateRequestReviewRebateComponent implements OnInit {
  //#region Properties & Variables
  //Define Rebate Properties
  @ViewChild('defineRebate',{static: false}) defineRebate: RebateRequestDefineRebateComponent;
  //Options
  private currentlySelectedOptionId: string = "";
  private isOptionSelected: boolean = false;
  private longHaulRequestOptions: LongHaulRequestOption[] = [];
  private selectedLongHaulRequestOption: LongHaulRequestOption = new LongHaulRequestOption();
  private isSelectedOptionRejected: boolean = true;
  private isOptionSubmitted: boolean = false;
  private isSubmitButtonDisplayed: boolean = false;
  //private isWorkFlowResponseReady: boolean = false;
  private isWorkFlowResponseNotValid: boolean = false;
  public isRequestSucceeded: boolean = false;
  //Review Rebate Request
  private longHaulReviewRebate: LongHaulReviewRebate = new LongHaulReviewRebate();
  private longHaulRequestOptionsDoneReview: LongHaulOptionRebateReview[] = [];
  private longHaulReviewRebateResponseObject: ResponseObject = new ResponseObject();
  private optionsArrayIndex: number = 0;
  //User Properties
  public currentUser: User = new User();
  //WorkFlow Decision
  //private workFlowResponseDecision: string;
  //Acceptance Cycle
  private optionLoadedData: LongHaulDefineRebate = new LongHaulDefineRebate();
  private noOfReviewedOptionsDone: number = 0;
  //Request History
  private isRequestHistoryComponent: boolean = false;
  public submitConfirmationMode: ConfirmationMode = ConfirmationMode.Success;
  //#endregion

  constructor(private longHaulService: LongHaulService, private globalServices: GlobalServices, private router: Router, private authenticationService: AuthenticationService) {
    //this.currentUser = this.globalServices.user;
    this.currentUser = this.authenticationService.currentUserValue;
    if(history.state.data && history.state.data.isCompleted){
      this.isRequestHistoryComponent = true;
    }
  }

  ngOnInit() {
    //Enable Loader
    this.globalServices.isLoaderEnabled = true;
  }
  onDefineRebateLoadedFlag(flag: boolean) {
    if(flag){
      //Hide [Measurement Committee Decision Component]
      //[Define Rebate Component] Fires Event Emitter
      //[Review Rebate Component] Set Boolean through [Define Rebate Component]
      this.defineRebate.measurementCommitteeDecision.isReviewRebateComponent = true;
      this.defineRebate.isReviewRebateAdmin = true;
      this.longHaulRequestOptions = this.defineRebate.rebateRequest.rebateRequestLoaded.LongHaulRequestOptions;
      this.defineRebate.isDefineRebateComponent = false;
      this.optionLoadedData = this.defineRebate.getDefineRebateResponse;
      this.countOptionsDone();
    }
  }
  countOptionsDone(): void {
    for(let i: number = 0; i < this.optionLoadedData.LongHaulOptionsRebate.length; i++){
      if(this.optionLoadedData.LongHaulOptionsRebate[i].MeasurementDecisionId == Decision.Accept){
        let longHaulRequestOptionDoneReview : LongHaulOptionRebateReview = new LongHaulOptionRebateReview();
        longHaulRequestOptionDoneReview.Id = this.optionLoadedData.LongHaulOptionsRebate[i].Id;
        longHaulRequestOptionDoneReview.DecisionId = this.optionLoadedData.LongHaulOptionsRebate[i].MeasurementDecisionId;
        longHaulRequestOptionDoneReview.Notes = this.optionLoadedData.LongHaulOptionsRebate[i].Notes;
        longHaulRequestOptionDoneReview.IsOptionDone = true;
        this.longHaulRequestOptionsDoneReview.push(longHaulRequestOptionDoneReview);
        this.noOfReviewedOptionsDone++;
      }
    }
    //Enable Loader
    this.globalServices.isLoaderEnabled = false;
  }
  onOptionSelected(optionId: string) {
    //Option Id Emitted from Define Rebate Component
    this.currentlySelectedOptionId = optionId;
    //Make Sure Rejection Reason not Displayed
    this.isSelectedOptionRejected = true;
    //Option Selected
    if(optionId != ""){
      //Show Option Details
      this.isOptionSelected = true;
      //selectedLongHaulRequestOption => binded Object
      //Load Original Options Details
      this.selectedLongHaulRequestOption = this.longHaulRequestOptions.filter(o => o.Id == optionId)[0];
      //Load Options Defined Rebate Percentage & Review Rebate Perecentage Decision - Notes
      let selectedLongHaulRequestOptionLoaded = this.optionLoadedData.LongHaulOptionsRebate.filter(o => o.Id == optionId)[0];
      //Review Rebate Second -> ...N Time
      //Check Review Rebate Mode
      let optionReviewedCurently: LongHaulOptionRebateReview = this.getCurrentReviewedOption();
      //[01] New Mode
      this.selectedLongHaulRequestOption.IsUpdatePercentageEnabled = false;
      if(selectedLongHaulRequestOptionLoaded.MeasurementDecisionId == null){
        this.setReviewRebateMode(ReviewRebateMode.New);
        //Bind Decision & Notes
        if(optionReviewedCurently != undefined){
          //Binded Current Step Decision
          if(optionReviewedCurently.DecisionId == Decision.Accept){
            this.selectedLongHaulRequestOption.RebatePercentageReviewDecision = "true";
          } else if(optionReviewedCurently.DecisionId == Decision.Reject){
            this.selectedLongHaulRequestOption.RebatePercentageReviewDecision = "false";
            this.selectedLongHaulRequestOption.MeasurementCommiteeReviewRebateNotes = optionReviewedCurently.Notes;
            this.isSelectedOptionRejected = false;
          }
        }
      }
      //[02] Edit Mode (Rejected Option)
      else if(selectedLongHaulRequestOptionLoaded.MeasurementDecisionId != null && selectedLongHaulRequestOptionLoaded.MeasurementDecisionId == Decision.Reject){
        this.setReviewRebateMode(ReviewRebateMode.Edit);
        //Bind Decision & Notes
        if(optionReviewedCurently == undefined){
          //[A] Bind Fetched from System
          this.selectedLongHaulRequestOption.RebatePercentageReviewDecision = "false";
          this.selectedLongHaulRequestOption.RebatePercentageReviewDecisionValue = "Rejected";
          this.selectedLongHaulRequestOption.MeasurementCommiteeReviewRebateNotes = selectedLongHaulRequestOptionLoaded.MeasurementRejectionReason;
          this.isSelectedOptionRejected = false;
        }
        //[B] Binded Current Step Decision
        else {
          if(optionReviewedCurently.DecisionId == Decision.Accept){
            this.selectedLongHaulRequestOption.RebatePercentageReviewDecision = "true";
            this.selectedLongHaulRequestOption.RebatePercentageReviewDecisionValue = "Rejected";
          } else if(optionReviewedCurently.DecisionId == Decision.Reject){
            this.selectedLongHaulRequestOption.RebatePercentageReviewDecision = "false";
            this.selectedLongHaulRequestOption.RebatePercentageReviewDecisionValue = "Accepted";
            this.selectedLongHaulRequestOption.MeasurementCommiteeReviewRebateNotes = optionReviewedCurently.Notes;
            this.isSelectedOptionRejected = false;
          }
        }
      }
      //[03] Details Mode (Accepted Option)
       else if(selectedLongHaulRequestOptionLoaded.MeasurementDecisionId != null && selectedLongHaulRequestOptionLoaded.MeasurementDecisionId == Decision.Accept){
        this.setReviewRebateMode(ReviewRebateMode.Details);
        //Bind Decision & Notes
        if(optionReviewedCurently == undefined){
          //[A] Bind Fetched from System
          this.selectedLongHaulRequestOption.RebatePercentageReviewDecision = "true";
          this.selectedLongHaulRequestOption.RebatePercentageReviewDecisionValue = "Accepted";
          this.selectedLongHaulRequestOption.MeasurementCommiteeReviewRebateNotes = selectedLongHaulRequestOptionLoaded.MeasurementRejectionReason;
        }
        //[B] Binded Current Step Decision
        else {
          if(optionReviewedCurently.DecisionId == Decision.Accept){
            this.selectedLongHaulRequestOption.RebatePercentageReviewDecision = "true";
            this.selectedLongHaulRequestOption.RebatePercentageReviewDecisionValue = "Accepted";
          } else if(optionReviewedCurently.DecisionId == Decision.Reject){
            this.selectedLongHaulRequestOption.RebatePercentageReviewDecision = "false";
            this.selectedLongHaulRequestOption.RebatePercentageReviewDecisionValue = "Rejected";
            this.selectedLongHaulRequestOption.MeasurementCommiteeReviewRebateNotes = optionReviewedCurently.Notes;
            this.isSelectedOptionRejected = false;
          }
        }
      }
    } else {
      this.isOptionSelected = false;
      this.selectedLongHaulRequestOption = new LongHaulRequestOption();
    }
  }
  setReviewRebateMode(modeId: ReviewRebateMode): void {
    this.selectedLongHaulRequestOption.ReviewRebateMode = modeId;
    if(this.isRequestHistoryComponent)
      this.selectedLongHaulRequestOption.ReviewRebateMode = ReviewRebateMode.Details;
  }
  getCurrentReviewedOption(): LongHaulOptionRebateReview {
    return this.longHaulReviewRebate.LongHaulOptionsRebateReview.filter(o => o.Id == this.currentlySelectedOptionId)[0];
  }
  onDecisionChange(): void {
    this.isSelectedOptionRejected = JSON.parse(this.selectedLongHaulRequestOption.RebatePercentageReviewDecision);
  }
  addOptionRebatePercentageReviewDecision(): void {
    let checkOptionAdded = this.longHaulReviewRebate.LongHaulOptionsRebateReview.filter(o => o.Id == this.selectedLongHaulRequestOption.Id)[0];
    if(checkOptionAdded == undefined) {
      this.longHaulReviewRebate.LongHaulOptionsRebateReview[this.optionsArrayIndex] = new LongHaulOptionRebateReview();
      this.longHaulReviewRebate.LongHaulOptionsRebateReview[this.optionsArrayIndex].Id = this.selectedLongHaulRequestOption.Id;
      this.longHaulReviewRebate.LongHaulOptionsRebateReview[this.optionsArrayIndex].DecisionId = JSON.parse(this.selectedLongHaulRequestOption.RebatePercentageReviewDecision) ? Decision.Accept : Decision.Reject;
      this.longHaulReviewRebate.LongHaulOptionsRebateReview[this.optionsArrayIndex].Notes = this.selectedLongHaulRequestOption.MeasurementCommiteeReviewRebateNotes;
      this.optionsArrayIndex++;
    } else {
      checkOptionAdded.DecisionId = JSON.parse(this.selectedLongHaulRequestOption.RebatePercentageReviewDecision) ? Decision.Accept : Decision.Reject;
      checkOptionAdded.Notes = this.selectedLongHaulRequestOption.MeasurementCommiteeReviewRebateNotes;
    }
    this.isOptionSelected = false;
    this.isSubmitButtonDisplayed = true;
    this.defineRebate.currentSelctedOption = "null";
    this.defineRebate.isOptionDetailsSelected = false;
    this.isOptionSubmitted = false;
    this.defineRebate.longHaulRequestOptions.filter(o => o.Id == this.selectedLongHaulRequestOption.Id)[0].IsOptionAdminDone = true;
    // if(this.longHaulRequestOptions.length == this.longHaulReviewRebate.LongHaulOptionsRebateReview.length)
    //   this.isWorkFlowResponseReady = true;
    this.defineRebate.isOptionsRebateArrNotValid = false;
    const el = document.getElementById('ddlOptions');
    el.scrollIntoView({behavior:'smooth'});
    this.isSelectedOptionRejected = true;
  }
  submit(): void {
    //Options Validations
    if((this.longHaulRequestOptions.length - this.noOfReviewedOptionsDone) != this.longHaulReviewRebate.LongHaulOptionsRebateReview.length){
      this.defineRebate.isOptionsRebateArrNotValid = true;
      const el = document.getElementById('ddlOptions');
      el.focus();
    } else {
      //Enable Loader
      this.globalServices.isLoaderEnabled = true;
      //WorkFlow Decision Validation
      this.defineRebate.isOptionsRebateArrNotValid = false;
      // if(this.workFlowResponseDecision == undefined){
      //   this.isWorkFlowResponseNotValid = true;
      // } else {
        //Form Valid
        this.longHaulReviewRebate.LongHaulRequestId = this.defineRebate.rebateRequest.rebateRequestLoaded.Id;
        //this.longHaulReviewRebate.WorkFlowResponse = JSON.parse(this.workFlowResponseDecision) ? WorkFlowDecision.Accept : WorkFlowDecision.Reject;
        this.longHaulReviewRebate.MeasurementCommitteeAdminEmail = this.currentUser.UserName != "" ? this.currentUser.UserName : this.currentUser.Email;
        //this.longHaulReviewRebate.MeasurementCommitteeAdminEmail = "ahmed.abdelgwad@linkdev.com";
        //Check Measurement Flow Decision
        let measurementFlowDecision: boolean = true;
        for(let i: number = 0; i < this.longHaulReviewRebate.LongHaulOptionsRebateReview.length; i++){
          if(this.longHaulReviewRebate.LongHaulOptionsRebateReview[i].DecisionId == Decision.Reject)
            measurementFlowDecision = false;
        }
        if(measurementFlowDecision)
          this.longHaulReviewRebate.WorkFlowResponse = WorkFlowDecision.Accept;
        else
          this.longHaulReviewRebate.WorkFlowResponse = WorkFlowDecision.Reject;
        this.reviewOptionsRebate();
      // }
    }
  }
  reviewOptionsRebate(): void {
    for(let i: number = 0; i < this.longHaulRequestOptionsDoneReview.length; i++){
      this.longHaulReviewRebate.LongHaulOptionsRebateReview.push(this.longHaulRequestOptionsDoneReview[i]);
    }
    this.longHaulService.reviewRebate(this.longHaulReviewRebate).subscribe(
      data => this.longHaulReviewRebateResponseObject = data,
      () => console.log("Something went wrong!!"),
      () => this.reviewOptionsRebateCompleted()
    );
  }
  reviewOptionsRebateCompleted(): void {
    if(!this.longHaulReviewRebateResponseObject.Success) {
      //Enable Error / Warning
      if(this.longHaulReviewRebateResponseObject.ErrorMessages[0] == ErrorsEnum.InternalServerError.toString())
        this.submitConfirmationMode = ConfirmationMode.Error;
      else if(this.longHaulReviewRebateResponseObject.ErrorMessages[0] == ErrorsEnum.TaskCompletedByAnotherUser.toString())
        this.submitConfirmationMode = ConfirmationMode.Warning;
    }
    this.isRequestSucceeded = true;
    //Disable Loader
    this.globalServices.isLoaderEnabled = false;
  }
  onWorkFlowResponseChange(): void {}
  //Cancel
  // cancelReviewingPercentage(): void {
  //   this.isOptionSelected = false;
  //   this.selectedLongHaulRequestOption = new LongHaulRequestOption();
  //   //this.defineRebate.cancelAddingPercentage();
  // }
  later(): void {
    this.router.navigateByUrl('/myTasks');
  }
}

enum Decision {
  Accept = 1,
  Reject = 3
}

enum WorkFlowDecision {
  Reject = 0,
  Accept = 1
}

enum ReviewRebateMode{
  New = 1,
  Edit = 2,
  Details = 3
}

enum ConfirmationMode {
  Success  = 1,
  Warning = 2,
  Error = 3
}
